export const LATEST_SEASON_ID = 'total';

export const PLAYERS = [
  {
    id: 8474056,
    firstName: 'P.K.',
    lastName: 'Subban',
    stats: {
      'total': {
        teamId: 1,
        games: 0,
        goals: 0,
        assists: 0,
        points: 0,
        plusMinus: 0,
      },
      '20212022p': {
        teamId: 1,
        games: 0,
        goals: 0,
        assists: 0,
        points: 0,
        plusMinus: 0,
      },
      '20212022': {
        teamId: 1,
        games: 77,
        goals: 5,
        assists: 17,
        points: 22,
        plusMinus: -8,
      },
      '20202021p': {
        teamId: 1,
        games: 0,
        goals: 0,
        assists: 0,
        points: 0,
        plusMinus: 0,
      },
      '20202021': {
        teamId: 1,
        games: 44,
        goals: 5,
        assists: 14,
        points: 19,
        plusMinus: -16,
      },
      '20192020p': {
        teamId: 1,
        games: 0,
        goals: 0,
        assists: 0,
        points: 0,
        plusMinus: 0,
      },
      '20192020': {
        teamId: 1,
        games: 68,
        goals: 7,
        assists: 11,
        points: 18,
        plusMinus: -21,
      },
      '20182019p': {
        teamId: 18,
        games: 6,
        goals: 1,
        assists: 2,
        points: 3,
        plusMinus: -3,
      },
      '20182019': {
        teamId: 18,
        games: 63,
        goals: 9,
        assists: 22,
        points: 31,
        plusMinus: 5,
      },
      '20172018p': {
        teamId: 18,
        games: 13,
        goals: 4,
        assists: 5,
        points: 9,
        plusMinus: -2,
      },
      '20172018': {
        teamId: 18,
        games: 82,
        goals: 16,
        assists: 43,
        points: 59,
        plusMinus: 18,
      },
      '20162017p': {
        teamId: 18,
        games: 22,
        goals: 2,
        assists: 10,
        points: 12,
        plusMinus: 5,
      },
      '20162017': {
        teamId: 18,
        games: 66,
        goals: 10,
        assists: 30,
        points: 40,
        plusMinus: -8,
      },
    },
  },
  {
    id: 8470642,
    firstName: 'Shea',
    lastName: 'Weber',
    stats: {
      'total': {
        teamId: 8,
        games: 0,
        goals: 0,
        assists: 0,
        points: 0,
        plusMinus: 0,
      },
      '20212022p': {
        teamId: 8,
        games: 0,
        goals: 0,
        assists: 0,
        points: 0,
        plusMinus: 0,
      },
      '20212022': {
        teamId: 8,
        games: 0,
        goals: 0,
        assists: 0,
        points: 0,
        plusMinus: 0,
      },
      '20202021p': {
        teamId: 8,
        games: 22,
        goals: 1,
        assists: 5,
        points: 6,
        plusMinus: 4,
      },
      '20202021': {
        teamId: 8,
        games: 48,
        goals: 6,
        assists: 13,
        points: 19,
        plusMinus: -4,
      },
      '20192020p': {
        teamId: 8,
        games: 10,
        goals: 3,
        assists: 2,
        points: 5,
        plusMinus: 3,
      },
      '20192020': {
        teamId: 8,
        games: 65,
        goals: 15,
        assists: 21,
        points: 36,
        plusMinus: 8,
      },
      '20182019p': {
        teamId: 8,
        games: 0,
        goals: 0,
        assists: 0,
        points: 0,
        plusMinus: 0,
      },
      '20182019': {
        teamId: 8,
        games: 58,
        goals: 14,
        assists: 19,
        points: 33,
        plusMinus: 15,
      },
      '20172018p': {
        teamId: 8,
        games: 0,
        goals: 0,
        assists: 0,
        points: 0,
        plusMinus: 0,
      },
      '20172018': {
        teamId: 8,
        games: 26,
        goals: 6,
        assists: 10,
        points: 16,
        plusMinus: -8,
      },
      '20162017p': {
        teamId: 8,
        games: 6,
        goals: 1,
        assists: 2,
        points: 3,
        plusMinus: 1,
      },
      '20162017': {
        teamId: 8,
        games: 78,
        goals: 17,
        assists: 25,
        points: 42,
        plusMinus: 20,
      },
    },
  },
];

export const TEAMS = [
  {
    id: 1,
    location: 'New Jersey',
    name: 'Devils',
    stats: {
      '20212022p': {
        win: 0,
        loss: 0,
        overtimeLoss: null,
        type: 'playoff',
        round: 'No playoffs',
        points: null,
      },
      '20212022': {
        win: 27,
        loss: 46,
        overtimeLoss: 9,
        type: 'league',
        round: null,
        points: 63,
      },
      '20202021p': {
        win: 0,
        loss: 0,
        overtimeLoss: null,
        type: 'playoff',
        round: 'No playoffs',
        points: null,
      },
      '20202021': {
        win: 19,
        loss: 30,
        overtimeLoss: 7,
        type: 'league',
        round: null,
        points: 45,
      },
      '20192020p': {
        win: 0,
        loss: 0,
        overtimeLoss: null,
        type: 'playoff',
        round: 'No playoffs',
        points: null,
      },
      '20192020': {
        win: 28,
        loss: 29,
        overtimeLoss: 12,
        type: 'league',
        round: null,
        points: 68,
      },
    },
  },
  {
    id: 8,
    location: 'Montreal',
    name: 'Canadiens',
    stats: {
      '20212022p': {
        win: 0,
        loss: 0,
        overtimeLoss: null,
        type: 'playoff',
        round: 'No playoffs',
        points: null,
      },
      '20212022': {
        win: 22,
        loss: 49,
        overtimeLoss: 11,
        type: 'league',
        round: null,
        points: 55,
      },
      '20202021p': {
        win: 13,
        loss: 9,
        overtimeLoss: null,
        type: 'playoff',
        round: 'CUP FINAL',
        points: null,
      },
      '20202021': {
        win: 24,
        loss: 21,
        overtimeLoss: 11,
        type: 'league',
        round: null,
        points: 59,
      },
      '20192020p': {
        win: 2,
        loss: 4,
        overtimeLoss: null,
        type: 'playoff',
        round: 'Round 1',
        points: null,
      },
      '20192020': {
        win: 28,
        loss: 29,
        overtimeLoss: 12,
        type: 'league',
        round: null,
        points: 68,
      },
      '20182019p': {
        win: 0,
        loss: 0,
        overtimeLoss: null,
        type: 'playoff',
        round: 'No playoffs',
        points: null,
      },
      '20182019': {
        win: 44,
        loss: 30,
        overtimeLoss: 8,
        type: 'league',
        round: null,
        points: 96,
      },
      '20172018p': {
        win: 0,
        loss: 0,
        overtimeLoss: null,
        type: 'playoff',
        round: 'No playoffs',
        points: null,
      },
      '20172018': {
        win: 29,
        loss: 40,
        overtimeLoss: 13,
        type: 'league',
        round: null,
        points: 71,
      },
      '20162017p': {
        win: 2,
        loss: 4,
        overtimeLoss: null,
        type: 'playoff',
        round: 'Round 1',
        points: null,
      },
      '20162017': {
        win: 47,
        loss: 26,
        overtimeLoss: 9,
        type: 'league',
        round: null,
        points: 103,
      },      
    },
  },
  {
    id: 18,
    location: 'Nashville',
    name: 'Predators',
    stats: {
      '20182019p': {
        win: 2,
        loss: 4,
        overtimeLoss: null,
        type: 'playoff',
        round: 'Round 1',
        points: null,
      },
      '20182019': {
        win: 47,
        loss: 29,
        overtimeLoss: 6,
        type: 'league',
        round: null,
        points: 100,
      },
      '20172018p': {
        win: 3,
        loss: 4,
        overtimeLoss: null,
        type: 'playoff',
        round: 'Round 2',
        points: null,
      },
      '20172018': {
        win: 53,
        loss: 18,
        overtimeLoss: 11,
        type: 'league',
        round: null,
        points: 117,
      },
      '20162017p': {
        win: 2,
        loss: 4,
        overtimeLoss: null,
        type: 'playoff',
        round: 'CUP FINAL',
        points: null,
      },
      '20162017': {
        win: 41,
        loss: 29,
        overtimeLoss: 12,
        type: 'league',
        round: null,
        points: 94,
      },
    },
  },
];

export const SEASONS = [
  {
    id: 'total',
    name: 'Totals since trade',
  },
  {
    id: '20212022p',
    name: 'Playoffs 2022',
  },
  {
    id: '20212022',
    name: '2021-2022',
  },
  {
    id: '20202021p',
    name: 'Playoffs 2021',
  },
  {
    id: '20202021',
    name: '2020-2021',
  },
  {
    id: '20192020p',
    name: 'Playoffs 2020',
  },
  {
    id: '20192020',
    name: '2019-2020',
  },
  {
    id: '20182019p',
    name: 'Playoffs 2019',
  },
  {
    id: '20182019',
    name: '2018-2019',
  },
  {
    id: '20172018p',
    name: 'Playoffs 2018',
  },
  {
    id: '20172018',
    name: '2017-2018',
  },
  {
    id: '20162017p',
    name: 'Playoffs 2017',
  },
  {
    id: '20162017',
    name: '2016-2017',
  }
];
